import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Transition } from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/outline';

import { classNames } from 'utils/functions';

export default function SidebarItemParent({
  sidebarItem,
  paths,
  children,
  ...rest
}: {
  sidebarItem: any;
  paths: string[];
  children: React.ReactNode;
}) {
  const location = useLocation();
  const isActive = paths.includes(location.pathname);

  const [isOpen, setIsOpen] = useState(isActive);

  return (
    <div>
      <button
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className={`${
          isActive
            ? 'border-l-8 bg-gray-100 text-gray-900'
            : 'text-gray-600 hover:border-l-8 hover:bg-gray-50 hover:text-gray-900 focus:border-l-8 focus:bg-gray-50 focus:text-gray-900'
        } group flex w-full items-center rounded-md border-primary-600 px-2 py-2 text-sm font-medium transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-100`}
        {...rest}
      >
        <sidebarItem.icon
          className={classNames(
            sidebarItem.current ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500',
            'mr-3 h-6 w-6 flex-shrink-0'
          )}
          aria-hidden="true"
        />
        {sidebarItem.title}
        <ChevronRightIcon
          className={`${
            isOpen ? 'rotate-90 text-gray-500' : 'text-gray-400'
          } ml-auto h-5 w-5 transform transition-all duration-150 ease-in-out group-hover:text-gray-400 group-focus:text-gray-400`}
        />
      </button>

      <Transition
        show={isOpen}
        className="pt-1"
        enter="transition ease-out duration-100"
        enterFrom="scale-95"
        enterTo="scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="scale-100"
        leaveTo="scale-95"
      >
        {children}
      </Transition>
    </div>
  );
}
